import { render, staticRenderFns } from "./iconSvgNote.vue?vue&type=template&id=52fdb778&scoped=true&"
import script from "./iconSvgNote.vue?vue&type=script&lang=js&"
export * from "./iconSvgNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fdb778",
  null
  
)

export default component.exports